import React from "react";
import { UserRound } from "lucide-react";
import { PageBanner } from "@/components/site/PageBanner";

export default function About() {
  return (
    <>
    <PageBanner title="About KMT" crumb="About" />
    <div className="mx-auto max-w-7xl px-5 py-20 md:px-10">
      <p className="eyebrow">Our story</p>
      <h2 className="mt-4 max-w-4xl font-display text-3xl md:text-4xl">A familiar face behind every ride.</h2>
      <div className="gold-rule mt-8 w-40" />
      <div className="mt-16 grid items-start gap-14 lg:grid-cols-[0.8fr_1.2fr]">
        <div className="grid aspect-[4/5] w-full max-w-sm place-items-center rounded-md border border-dashed border-gold/50 bg-aubergine/60 text-center" data-testid="about-photo-placeholder">
          <div className="p-6">
            <UserRound className="mx-auto text-gold/70" size={48} />
            <p className="mt-3 text-[14px] text-mist/70">[Photo of Kyia — placeholder]</p>
          </div>
        </div>
        <div className="flex flex-col gap-8">
          <p className="font-script text-4xl leading-snug text-gold md:text-5xl" data-testid="about-because-line">
            Because getting there… [full line from the Brand Bible]
          </p>
          <p className="text-[15px] leading-relaxed text-mist/85">
            KMT Private Rides is owned and run by Kyia. Every request is read, priced and confirmed by her personally, so you always know who you're riding with.
          </p>
          <p className="rounded-md border border-dashed border-gold/50 p-5 text-[15px] text-mist/75" data-testid="about-bio-placeholder">
            [Placeholder: Kyia's story and final About copy from the Brand Bible.]
          </p>
        </div>
      </div>
    </div>
    </>
  );
}
